import { OperatorDto } from '@app/core/api/operators';

export type AuthProfileModel = OperatorDto;
